import { InjectionToken } from '@angular/core';

export const PAGE_SCROLL_STRATEGY =
  new InjectionToken<PageScrollStrategy>('PageScrollStrategy');

export interface PageScrollStrategy {
  scroll(): void;
}
